module.exports = __webpack_public_path__ + "static/media/confetti-non-looping.cf9bc3f7.gif";


//////////////////
// WEBPACK FOOTER
// ./src/theme/Allianz/images/confetti-non-looping.gif
// module id = 4032
// module chunks = 0